import { TriangleAlert } from 'lucide-react';

/**
 * Shown when web/config.js is missing or still holds the placeholder key. Deliberately NOT localised:
 * i18n has not booted at this point, and this is an operator message, not product copy.
 */
export function ConfigErrorScreen({ message }: { message: string }) {
  return (
    <div className="grid min-h-full place-items-center bg-canvas p-6">
      <div className="max-w-md rounded-lg border border-hairline bg-card p-8 shadow-card">
        <TriangleAlert className="size-6 text-danger" aria-hidden="true" />
        <h1 className="mt-4 text-xl font-semibold text-ink">The portal is not configured</h1>
        <p className="mt-2 text-base text-ink-secondary">{message}</p>
      </div>
    </div>
  );
}
